import { dashboardService } from "@/api/dashboard";
import { SummarySection } from "@/components/dashboard/SummarySection";
import { EmployeeSummary } from "@/components/dashboard/EmployeeSummary";
import { DashboardLayout } from "@/components/layout/DashboardLayout";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useAuth } from "@/contexts/AuthContext";
import { useQuery } from "@tanstack/react-query";
import { Calendar, Upload, Users, Settings } from "lucide-react";
import { useNavigate } from "react-router-dom";

export default function Dashboard() {
  const { user } = useAuth();
  const navigate = useNavigate();

  const { data: summary, isLoading: isSummaryLoading } = useQuery({
    queryKey: ["dashboard-summary"],
    queryFn: dashboardService.getSummary,
    enabled: !!user,
  });

  return (
    <DashboardLayout>
      <div className="space-y-6">
        <div>
          <h2 className="text-2xl font-bold text-foreground">
            Welcome back, {user?.firstName}!
          </h2>
          <p className="text-muted-foreground mt-1">
            Here's what you can do today
          </p>
        </div>

        {(user?.roles?.includes("hr") || user?.roles?.includes("admin")) && (
          <Card className="shadow-soft mb-3">
            <CardHeader>
              <CardTitle>Quick Actions</CardTitle>
            </CardHeader>
            <CardContent>
              <div className="flex flex-wrap gap-2">
                <Button
                  variant="outline"
                  onClick={() => navigate("/hr/employees")}
                >
                  <Users className="h-4 w-4 mr-2" />
                  Manage Employees
                </Button>
                <Button
                  variant="outline"
                  onClick={() => navigate("/hr/holidays")}
                >
                  <Calendar className="h-4 w-4 mr-2" />
                  Manage Holidays
                </Button>
                <Button
                  variant="outline"
                  onClick={() => navigate("/hr/upload")}
                >
                  <Upload className="h-4 w-4 mr-2" />
                  Upload Data
                </Button>
                {user?.roles?.includes("admin") && (
                  <>
                    <Button
                      variant="outline"
                      onClick={() => navigate("/teams")}
                    >
                      <Users className="h-4 w-4 mr-2" />
                      Manage Teams
                    </Button>
                    <Button
                      variant="outline"
                      onClick={() => navigate("/leave-quotas")}
                    >
                      <Settings className="h-4 w-4 mr-2" />
                      Manage Leave Quota
                    </Button>
                  </>
                )}
              </div>
            </CardContent>
          </Card>
        )}

        {/* Summary Selection based on Role */}
        {user?.roles?.includes("admin") || user?.roles?.includes("hr") ? (
          <SummarySection data={summary} isLoading={isSummaryLoading} />
        ) : (
          <EmployeeSummary data={summary} isLoading={isSummaryLoading} />
        )}
      </div>
    </DashboardLayout>
  );
}
